/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Selectprospectsfromsalesforce4Inputs */

const en_coinvestments_selectprospectsfromsalesforce4 = /** @type {(inputs: Coinvestments_Selectprospectsfromsalesforce4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Prospects`)
};

/**
* | output |
* | --- |
* | "Select Prospects" |
*
* @param {Coinvestments_Selectprospectsfromsalesforce4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_selectprospectsfromsalesforce4 = /** @type {((inputs?: Coinvestments_Selectprospectsfromsalesforce4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Selectprospectsfromsalesforce4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_selectprospectsfromsalesforce4(inputs)
});
export { coinvestments_selectprospectsfromsalesforce4 as "coInvestments_selectProspectsFromSalesforce" }